import React, { useEffect, useState, useContext, useCallback } from "react";
import { AppContext } from "store/AppContext";
import { Grid } from "@material-ui/core";
import AtkvaediCountCard from "../components/cards/AtkvaediCountCard";
import SamantektAtkvaediTable from "../components/tables/SamantektAtkvaediTable";
import SamantektAdstodTable from "../components/tables/SamantektAdstodTable";
import TalningDoughnut from "./components/Doughnuts/TalningDoughnut";
import AdstodVeittDoughnut from "./components/Doughnuts/AdstodVeittDoughnut";
import AdstodVegnaDoughnut from "./components/Doughnuts/AdstodVegnaDoughnut";
import NylegAtkvaediTable from "../components/tables/NylegAtkvaediTable";
import Filters from "./components/Filters";
import KosningSelect from "pages/tolfraedi/components/KosningSelect";
import { getAtkvaediCounts, getAtkvaediSummary, getLatestAtkvaediByKosning } from 'common/services/apiService';


export default function Maelibord() {
  const context = useContext(AppContext);
  const [kosningId, setKosningId] = useState('');
  const [atkvaedi, setAtkvaedi] = useState([]);
  const [atkvaediSummary, setAtkvaediSummary] = useState({});
  const [atkvaediCounts, setAtkvaediCounts] = useState({});
  const [filters, setFilters] = useState(null);
  const [embaettiFromFilter, setEmbaettiFromFilter] = useState('');

  const fetchAtkvaediCounts = useCallback(async () => {
    const { data, isSuccess, error } = await getAtkvaediCounts(kosningId, filters, context, {});

    if (isSuccess) {
      setAtkvaediCounts(data);
    } else {
      setAtkvaediCounts({});
      console.error(error);
    }
  }, [kosningId, filters, context]);

  const fetchAtkvaediSummary = useCallback(async () => {
    const { data, isSuccess, error } = await getAtkvaediSummary(kosningId, filters, context, {});

    if (isSuccess) {
      setAtkvaediSummary(data); // filtera út aðsend - eða gera í bakenda kannski frekar.
    } else {
      setAtkvaediSummary({});
      console.error(error);
    }
  }, [kosningId, filters, context]);

  const fetchLatestAtkvaediByKosning = useCallback(async () => {
    const {data, isSuccess, error } = await getLatestAtkvaediByKosning(kosningId, filters, context, []);

    if (isSuccess) {
      setAtkvaedi(data.filter(a => a.atkvaediTegund.lysing !== "Aðsent atkvæði"));
    } else {
      console.error(error);
    }
  }, [kosningId, filters, context]);

  useEffect(() => {
    if (kosningId !== '') {
      fetchAtkvaediCounts();
      fetchAtkvaediSummary();
      fetchLatestAtkvaediByKosning();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kosningId]);
  

  // Refreshes data as soon as a filter changes
  // Note: Probably better to only update on action
  // if/when more filters are put in
  useEffect(() => {
    if (filters !== null) {
      fetchAtkvaediCounts();
      fetchAtkvaediSummary();
      fetchLatestAtkvaediByKosning();
    }
  }, [filters, fetchAtkvaediCounts, fetchAtkvaediSummary, fetchLatestAtkvaediByKosning]);
  
  return (
    <div>
      <Grid container direction="row">
        <KosningSelect setKosningId={setKosningId} />
      </Grid>

      <Grid container direction="row">
        <Filters setFilters={setFilters} setEmbaettiFromFilter={setEmbaettiFromFilter} />
      </Grid>

      <Grid container spacing={2}>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <AtkvaediCountCard
            title={"ATKVÆÐI Í DAG"}
            count={atkvaediCounts.today}
            avatarLetter={"D"}
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <AtkvaediCountCard
            title={"ATKVÆÐI Í GÆR"}
            count={atkvaediCounts.yesterday}
            avatarLetter={"G"}
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <AtkvaediCountCard
            title={"ATKVÆÐI Í VIKUNNI"}
            count={atkvaediCounts.currentWeek}
            avatarLetter={"V"}
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <AtkvaediCountCard
            title={"HEILDARFJÖLDI"}
            count={atkvaediCounts.total}
            avatarLetter={"H"}
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <SamantektAtkvaediTable talning={atkvaediSummary} embaetti={embaettiFromFilter} />
        </Grid>
        <Grid item lg={6} xs={12}>
          <SamantektAdstodTable talning={atkvaediSummary} embaetti={embaettiFromFilter} />
        </Grid>
        <Grid item lg={6} xs={12}>
          <TalningDoughnut talning={atkvaediSummary} embaetti={embaettiFromFilter} />
        </Grid>
        <Grid item lg={6} xs={12}>
          <AdstodVeittDoughnut talning={atkvaediSummary} embaetti={embaettiFromFilter} />
        </Grid>
        {/* <Grid item lg={4} xs={12}>
          <AdstodVegnaDoughnut talning={atkvaediSummary} embaetti={embaettiFromFilter} />
        </Grid> */}
        <Grid item xs={12}>
          <NylegAtkvaediTable atkvaedi={atkvaedi} embaetti={embaettiFromFilter} />
        </Grid>
      </Grid>
    </div>
  );
}
